/* eslint-disable */
import {
  call,
  put,
  take,
  select,
  // takeEvery,
  takeLatest,
  fork,
  // cancel,
} from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'

import { getLoggedUser, getLocation } from '@/state/selectors'
import { showModal } from '@/state/actions/modal'
import { routeDashboard } from '@/state/actions/routes'
import {
  editingStarted,
  editingEnded,
  editCommitted,
  userDisconnected,
} from '@/state/actions/editing'
import { NOTIFY_SERVER_EDITING_ENDED, EDITING_ENDED } from '@/state/types/editing'
import { ROUTE_NEWSLETTERS_EDIT } from '@/state/types/routes'
import { CHECK_PASSED, LOGIN_SUCCESS } from '@/state/types/auth'
import websocket from '@/helpers/websocket'

const RECORD_OPENED = 'RECORD_OPENED'
const RECORD_UPDATED = 'RECORD_UPDATED'
const USER_DISCONNECTED = 'USER_DISCONNECTED'

function initWebsocket(ws, user) {
  return eventChannel(emitter => {
    ws.onopen = () => {
      console.log('Connected to server websocket...')
    }
    ws.onerror = error => {
      console.log('WebSocket error ' + error)
      console.dir(error)
    }
    ws.onmessage = e => {
      let msg = null
      try {
        msg = JSON.parse(e.data)
      } catch (e) {
        console.error(`Error parsing : ${e.data}`)
      }
      if (msg) {
        if (user.id !== ((msg.user && msg.user.id) || (msg.nlData && msg.nlData.edited_by.id))) {
          emitter(msg)
        }
      }
    }
    // unsubscribe function
    return () => {
      console.log('Socket off')
    }
  })
}

function alertServerEditingEnded(ws, action) {
  // Send message to the server that user finished (leaved the page) editing
  ws.send(JSON.stringify(action))
}

function* sendMessagesToWS(ws) {
  yield takeLatest(NOTIFY_SERVER_EDITING_ENDED, alertServerEditingEnded, ws)
}

function* startAndListenWS(ws) {
  const auth = yield select(getLoggedUser)
  const channel = yield call(initWebsocket, ws, auth.user)
  while (true) {
    const msg = yield take(channel)
    const loc = yield select(getLocation)

    if (msg.type === RECORD_OPENED) {
      if (
        loc.type === ROUTE_NEWSLETTERS_EDIT &&
        msg.newsletterId &&
        msg.newsletterId === loc.payload.id
      ) {
        yield put(
          showModal({
            title: `Editing finished`,
            content: `User ${msg.user.full_name} has taken over editing of the newsletter.`,
            sticky: true,
            hideClose: true,
            buttonActions: [{ label: 'Ok', action: routeDashboard }],
          }),
        )
      }

      yield put(editingStarted({ user: msg.user, newsletterId: msg.newsletterId }))
    } else if (msg.type === RECORD_UPDATED) {
      yield put(editCommitted({ ...msg }))
    } else if (msg.type === USER_DISCONNECTED) {
      yield put(userDisconnected({ userId: msg.userId }))
    } else if (msg.type === EDITING_ENDED) {
      yield put(editingEnded(msg.payload))
    }
  }
}

export default function* wsSagas() {
  // Wait for user login / auth passed message
  yield take(action => action.type === CHECK_PASSED || action.type === LOGIN_SUCCESS)
  // Initialize web socket
  const url = `${process.env.API_URL.replace(/^(http).*?/, 'ws')}/api/ws/`
  const ws = new websocket(url)
  // Now trigger the WS init and channel listener
  yield fork(startAndListenWS, ws)
  // Fork saga that listens to store messages and sends notifications to the server
  yield fork(sendMessagesToWS, ws)
}



// WEBPACK FOOTER //
// ./state/sagas/wsSagas.js